"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../Button/Button"));
const Button_module_css_1 = __importDefault(require("../public/Button.module.css"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const material_1 = require("@mui/material");
const ImgWithFallbackSrc = (_a) => {
    var { primarySrc, fallbackSrc } = _a, props = __rest(_a, ["primarySrc", "fallbackSrc"]);
    const [src, setSrc] = (0, react_1.useState)(primarySrc);
    return (react_1.default.createElement("img", Object.assign({ src: src, onError: () => setSrc(fallbackSrc) }, props)));
};
const normalizeValue = (value) => {
    if (!value)
        return null;
    return typeof value === "string" ? { url: value } : value;
};
const MediaLibraryButton = ({ value = null, onChange, onClear, mimeGroup, origin, disabled = false }) => {
    const effectiveMimeGroup = mimeGroup || "";
    const effectiveOrigin = (origin === null || origin === void 0 ? void 0 : origin.trim()) || window.location.origin;
    const [selectedFile, setSelectedFile] = (0, react_1.useState)(() => normalizeValue(value));
    (0, react_1.useEffect)(() => {
        setSelectedFile(prev => {
            const normalized = normalizeValue(value);
            if ((!prev && normalized) ||
                (prev && normalized && prev.url !== normalized.url)) {
                return normalized;
            }
            return prev;
        });
    }, [value]);
    const postMessageToQMS = () => {
        const message = {
            command: "toggle",
            type: "media-library",
            mimeGroup: effectiveMimeGroup,
            selectedFileUrl: (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.url) || ""
        };
        const isInIframe = window !== window.parent;
        const target = isInIframe ? window.parent : window;
        target.postMessage(message, effectiveOrigin);
    };
    (0, react_1.useEffect)(() => {
        const handleMessage = (event) => {
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) !== "media-library" || !event.data.file)
                return;
            const file = event.data.file;
            const completeFile = Object.assign(Object.assign({}, file), { url: file.url || "", thumbnailUrl: file.thumbnailUrl || file.thumbnail_url || null, file_name: file.file_name ||
                    file.fileName ||
                    file.name ||
                    (file.url ? file.url.split("/").pop() : "media") });
            setSelectedFile(completeFile);
            onChange(completeFile);
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [onChange, effectiveOrigin]);
    const handleClear = () => {
        setSelectedFile(null);
        onChange(null);
        if (onClear)
            onClear();
    };
    const openMediaLibrary = () => {
        if (!disabled)
            postMessageToQMS();
    };
    const handleRemoveFile = () => {
        if (!disabled)
            handleClear();
    };
    return (react_1.default.createElement("div", { style: { display: "flex", flexFlow: "column wrap" }, className: "justify-content-start w-50" }, (selectedFile === null || selectedFile === void 0 ? void 0 : selectedFile.url) ? (react_1.default.createElement("div", { className: "d-inline-flex align-items-center" },
        react_1.default.createElement(material_1.Tooltip, { title: selectedFile.file_name || "", placement: "top" },
            react_1.default.createElement("div", { onClick: disabled ? undefined : openMediaLibrary, style: {
                    width: "87px",
                    height: "65px",
                    borderColor: "var(--lightgray-color)",
                    borderRadius: "4px",
                    marginRight: "1rem",
                    cursor: disabled ? "default" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f7f7f7",
                    overflow: "hidden",
                    padding: "4px"
                } }, selectedFile.thumbnailUrl ? (react_1.default.createElement(ImgWithFallbackSrc, { "data-cy": "selectedMedia", primarySrc: selectedFile.thumbnailUrl, fallbackSrc: `${origin}/api/medialibrary${selectedFile.url}`, style: {
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                    borderRadius: "4px"
                }, crossOrigin: "use-credentials" })) : (react_1.default.createElement("span", { style: {
                    fontSize: "12px",
                    textAlign: "center",
                    wordBreak: "break-word",
                    padding: "4px"
                } }, selectedFile.file_name || "No preview")))),
        react_1.default.createElement(Button_1.default, { className: `${Button_module_css_1.default["button-container"]} p-0`, onClick: handleRemoveFile, icon: pro_solid_svg_icons_1.faTrashCan, iconColor: "var(--info-color)", variant: "empty", size: "small", dataCy: "deleteAppMedia", isDisabled: disabled }))) : (react_1.default.createElement("div", { className: `${Button_module_css_1.default["media-select-container"]} d-flex align-items-center justify-content-center`, onClick: disabled ? undefined : openMediaLibrary, id: "fileSelect", "data-cy": "fileSelect", style: { cursor: disabled ? "default" : "pointer" } },
        react_1.default.createElement("div", { className: "d-flex flex-column align-items-center", style: { rowGap: 10 } },
            react_1.default.createElement("img", { src: "/images/media-library.svg", style: { width: "55px" } }),
            react_1.default.createElement("span", { className: `${Button_module_css_1.default["media-select-text"]} ns-font-family-bold` }, "Browse Media Library"))))));
};
exports.default = MediaLibraryButton;
